<fa-icon class="pr-1" style="cursor: pointer; color: var(--primary-color);" *ngIf="toggleOn" (click)="refresh()" [icon]="faToggleOn" size="2x"></fa-icon>
<fa-icon class="pr-1" style="cursor: pointer; color: var(--primary-color);" *ngIf="!toggleOn" (click)="refresh()" [icon]="faToggleOff" size="2x"></fa-icon>
